import { useEffect } from 'react';
import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@/_components/checkbox';
import styles from './styles.module.scss';
import type { FormType } from '../approval-mat-form/types';

interface ConfirmDocumentationProps {
  valueApprove: keyof FormType;
  valueComment: keyof FormType;
  disableApprove?: boolean;
}

function ConfirmDocumentation({
  valueApprove,
  valueComment,
  disableApprove,
}: ConfirmDocumentationProps) {
  const { register, watch, control, setValue } = useFormContext<FormType>();

  const watchValueCheckbox = watch(valueApprove);
  const valueCheckboxReprove =
    watchValueCheckbox !== undefined && !watchValueCheckbox;

  useEffect(() => {
    if (disableApprove && watchValueCheckbox) {
      setValue(valueApprove, undefined);
    }
  }, [disableApprove, setValue, valueApprove, watchValueCheckbox]);

  return (
    <div className={styles.containerComment}>
      <p>
        Confirme se a documentação está com informação e qualidade adequadas.
      </p>

      <div className={styles.boxCheckbox}>
        <Controller
          control={control}
          name={valueApprove}
          render={({ field: { onChange } }) => (
            <Checkbox
              classNameLabel={classNames(
                styles.labelCheckbox,
                watchValueCheckbox && styles.labelCheckboxApproved,
              )}
              classNameCheckbox={classNames(
                watchValueCheckbox && styles.checkboxInfoApproved,
              )}
              id={`${valueApprove}-approve`}
              data-testid={`${valueApprove}-approve`}
              label="Aprovado"
              checked={!!watchValueCheckbox}
              disabled={disableApprove}
              onClick={() => {
                if (disableApprove) {
                  return;
                }

                onChange(true);
              }}
            />
          )}
        />

        <Controller
          control={control}
          name={valueApprove}
          render={({ field: { onChange } }) => (
            <Checkbox
              classNameLabel={classNames(
                styles.labelCheckbox,
                valueCheckboxReprove && styles.labelCheckboxReproved,
              )}
              classNameCheckbox={classNames(
                valueCheckboxReprove && styles.checkboxInfoReproved,
              )}
              id={`${valueApprove}-reprove`}
              data-testid={`${valueApprove}-reprove`}
              label="Reprovado"
              checked={valueCheckboxReprove}
              onClick={() => onChange(false)}
            />
          )}
        />
      </div>

      <div>
        <label>Campo para comentários:</label>
        <textarea
          {...register(valueComment)}
          data-testid={`${valueApprove}-comment`}
          placeholder="Digite um comentário"
        />
      </div>
    </div>
  );
}

export { ConfirmDocumentation };
